export default __webpack_public_path__ + "static/media/030-satellite-dish.b450633c.png";